import React, {useEffect, useState} from "react";

import './squadflixLiveView.css';
import {Link, useNavigate} from "react-router-dom";
import UseLiveCustomLinks from "../../movies/liveCustomLinks/hooks/useLiveCustomLinks";
import {useIntl} from "react-intl";
import ButtonV2 from "../../../shared/button-v2/button-v2";
import SpanishLeagueEventsRow from "../../squadflixHome/rows/SpanishLeagueEventsRow";
import {StremioChannelsRow} from "../../squadflixHome/rows/StremioChannelsRow";
import {cn} from "../../../../utils/utils";


function SquadflixLiveView({search, onWidthChange, links}) {
    const navigate = useNavigate();
    const {cat} = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    const {links: customLinks} = UseLiveCustomLinks();
    const [favouriteLinks, setFavouriteLinks] = useState(localStorage.getItem('favoriteAceLinks') ? JSON.parse(localStorage.getItem('favoriteAceLinks')) : []);
    const intl = useIntl();

    const [selectedCategory, setSelectedCategory] = useState(cat || "ownLinks");

    useEffect(() => {
        setSelectedCategory(cat || "ownLinks");
    }, [cat]);

    const openPlayer = (acestreamLink, custom = false) => {
        if (custom) {
            navigate("/squadflix/live/custom/play/" + acestreamLink.id);
        } else {
            navigate("/squadflix/live/" + acestreamLink.url);
        }
    };

    const renderLinks = (links, custom = false) => (
        <div className="ace-stream-link-list">
            {links.map((link) => (
                <div key={link.id} className="card mb-3" style={{width: '100%'}}>
                    <div className="card-body d-flex flex-column align-items-start">
                        <h5 className="card-title">{link.name}</h5>
                        <p className="card-text text-truncate" style={{maxWidth: '100%'}}>{link.link}
                            <span className="ms-2" style={{
                                cursor: 'pointer',
                            }} onClick={() => {
                                navigator.clipboard.writeText(`acestream://${link.link}`);
                                alert('Link copiado al portapapeles');
                            }}><i className="fa-solid fa-copy"></i></span></p>
                        <div className="mt-auto d-flex flex-row gap-3">
                            <ButtonV2 size="small" onClick={() => {
                                navigate(`/squadflix/live/custom/play/${link.id}`);
                            }}>Ver <i className="fa-solid fa-play ms-1"></i>
                            </ButtonV2>
                            <ButtonV2 size="small" onClick={() => {
                                window.open(`acestream://${link.id}`);
                            }}>Acestream <img height={25} className="ms-1" alt="Ace Stream"
                                              src="https://dashboard.snapcraft.io/site_media/appmedia/2017/02/icon_14.png"/>
                            </ButtonV2>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <div>
            <SpanishLeagueEventsRow/>
            <StremioChannelsRow/>
            <div className="ace-stream-category mt-4">
                <div className="ace-stream-category__own-links-header">
                    <button className={cn("ace-stream-category-title", {"isOpen": selectedCategory === "ownLinks"})}
                            onClick={() => {
                                if (selectedCategory === "ownLinks") {
                                    setSelectedCategory(null);
                                } else {
                                    setSelectedCategory("ownLinks");
                                }
                            }}>
                        <img
                            src="https://play-lh.googleusercontent.com/daJbjIyFdJ_pMOseXNyfZuy2mKOskuelsyUyj6AcGb0rV0sJS580ViqOTcSi-A1BUnI"
                            alt="" className="ace-stream-category-icon"/>
                        <span style={{marginLeft: 12}}>Tus LINKS</span>
                    </button>
                    <Link to="/squadflix/live/custom"
                          className="btn btn-sm btn-outline-secondary"
                          style={{
                              marginLeft: 8,
                              fontSize: 13
                          }}>Gestionar <i
                        className="fa-solid fa-arrow-up-right-from-square"></i></Link>
                </div>
                {renderLinks(customLinks, true)}
            </div>
        </div>
    );
}

export default SquadflixLiveView;
